import { computed, ref, watch } from '@vue/composition-api';

export function useLocalProp ({ props, emit }, propName, alias) {
  const propValue = props[propName];
  const internalValue = ref(propValue);
  watch(() => props[propName], (val) => {
    internalValue.value = val;
  });
  return computed({
    get () {
      return internalValue.value;
    },
    set (val) {
      internalValue.value = val;
      emit(`update:${alias || propName}`, val);
    },
  });
}

export default useLocalProp;
